import { I18n } from '@calendly/i18n'
import { useDispatch, useSelector } from 'react-redux'

import { MembershipsPicker } from 'features/memberships_picker'
import { useHomeTabs } from 'hooks/home/tabs'

import { ParticipantsList } from './participants_list'
import { membershipPickerInitialValueSelector, isPersonalEventTypeSelector } from '../../selectors'
import { addParticipant, removeParticipant } from '../../slice'


export const Content = ({ scopeType }) => {
  const dispatch = useDispatch()
  const { getTabScopeV2 } = useHomeTabs()
  const { _, id: tabScope } = getTabScopeV2()
  const isPersonalEventType = useSelector(isPersonalEventTypeSelector)

  const isWorkspaceScopeType = scopeType === 'workspace'
  const workspaceUuid = isWorkspaceScopeType ? tabScope : null
  const membershipPickerEntities = (isPersonalEventType || isWorkspaceScopeType)
    ? ['memberships'] : ['memberships', 'invitations', 'migrations']

  const membershipPickerInitialValue = useSelector(membershipPickerInitialValueSelector)

  const handleSelect = (member) => {
    dispatch(addParticipant(member))
  }

  const handleRemove = (member) => {
    dispatch(removeParticipant(member))
  }

  return (
    <MembershipsPicker
      entities={membershipPickerEntities}
      inputPlaceholder={I18n.t('publisher.event_types.edit_permissions_modal.input_placeholder')}
      initialValue={membershipPickerInitialValue}
      selectedSuggestionsComponent={ParticipantsList}
      onSelect={handleSelect}
      onRemove={handleRemove}
      workspaceUuid={workspaceUuid}
    />
  )
}
